'use client'
import { Card as ChakraCard } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { CardProps } from './Card.types'

export default forwardRef(function Card(
  props: CardProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraCard {...props} ref={ref} translate="no" />
})
